<div class="frame" fxLayout="column" fxLayoutGap="32px">
  <div class="item">
    <app-units-graph></app-units-graph>
  </div>
  <div class="item">
    <app-streams-graph></app-streams-graph>
  </div>
  <div class="item">
    <app-youtube-graph></app-youtube-graph>
  </div>
  <div class="item">
    <app-physicals-graph></app-physicals-graph>
  </div>
  <div class="item">
    <app-download-units-graph></app-download-units-graph>
  </div>
  <div class="item">
    <app-tiktok-graph></app-tiktok-graph>
  </div>
  <div class="item">
    <app-reactions-graph></app-reactions-graph>
  </div>
  <div class="item">
    <app-pr-analyzer-graph></app-pr-analyzer-graph>
  </div>
  <div class="item">
    <app-homepages-graph></app-homepages-graph>
  </div>
  <div class="item">
    <app-homepages-user-graph></app-homepages-user-graph>
  </div>
  <div class="footer-area"></div>
</div>